export interface MatchSegment {
  text: string;
  matched: boolean;
}

/**
 * Splits `text` around every case-insensitive occurrence of `query`, so a
 * result row can emphasise what the user typed. An empty query, or one that
 * does not occur, returns the whole text as one unmatched segment.
 */
export function splitOnMatch(text: string, query: string): MatchSegment[] {
  const needle = query.trim().toLowerCase();
  if (needle === '') return [{ text, matched: false }];
  const haystack = text.toLowerCase();
  const segments: MatchSegment[] = [];
  let cursor = 0;
  let found = haystack.indexOf(needle, cursor);
  while (found !== -1) {
    if (found > cursor) segments.push({ text: text.slice(cursor, found), matched: false });
    segments.push({ text: text.slice(found, found + needle.length), matched: true });
    cursor = found + needle.length;
    found = haystack.indexOf(needle, cursor);
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), matched: false });
  return segments.length > 0 ? segments : [{ text, matched: false }];
}
